import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

import { TotemPopup } from 'components/TotemPopup';

import { getExtendedFormattedDatetime } from 'helpers/dateTimes';

export type ConfirmedQuantityHistoryEntry = { createdAt: number; quantity?: number | null };

/** Ce que le fournisseur a successivement confirmé pour une référence. */
export const ConfirmedQuantityHistoryPopup = ({
    isOpen,
    setIsOpen,
    quantityHistoryValues,
}: {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    quantityHistoryValues: readonly ConfirmedQuantityHistoryEntry[];
}) => (
    <TotemPopup
        title="Historique des quantités confirmées"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        contentOverflow="visible"
    >
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>Créé le</TableHead>
                    <TableHead>Quantité</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {quantityHistoryValues.map(({ createdAt, quantity }, index) => (
                    <TableRow key={index}>
                        <TableCell>{getExtendedFormattedDatetime(createdAt)}</TableCell>
                        <TableCell>{quantity ?? 'Pas de valeur'}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TotemPopup>
);
